import { useAuth } from '../hooks/useAuth';
import { useJobsSync } from '../hooks/useJobsSync';
import ChildJobsView from './jobs/ChildJobsView';
import ParentJobsView from './jobs/ParentJobsView';

const DAVE_EMAIL = 'dave@activelylazy.co.uk';
const SAM_EMAIL = 'sam@activelylazy.co.uk';
const ALEX_EMAIL = 'alex@activelylazy.co.uk';
const TOM_EMAIL = 'tom@activelylazy.co.uk';

const CHILD_NAME_BY_EMAIL: Record<string, string> = {
  [ALEX_EMAIL]: 'Alex',
  [TOM_EMAIL]: 'Thomas',
};

export default function JobsPage() {
  const { user, isLoading } = useAuth();
  useJobsSync();

  if (isLoading || !user) {
    return (
      <div className="flex items-center justify-center h-40 text-gray-500">Loading...</div>
    );
  }

  const childName = CHILD_NAME_BY_EMAIL[user.email];
  const isParent = user.email === DAVE_EMAIL || user.email === SAM_EMAIL;
  const isDave = user.email === DAVE_EMAIL;

  if (childName) {
    return (
      <div className="px-4 py-4 sm:px-0">
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            {childName}'s Jobs
          </h2>
        </div>
        <ChildJobsView childName={childName} />
      </div>
    );
  }

  if (isParent) {
    return (
      <div className="px-4 py-4 sm:px-0">
        <ParentJobsView isDave={isDave} />
      </div>
    );
  }

  // Unknown user — shouldn't happen in practice
  return (
    <div className="flex items-center justify-center h-40 text-gray-500">
      Your account is not set up for jobs tracking.
    </div>
  );
}
